import React, { FunctionComponent } from 'react';
import moment from 'moment';
import { Form, Violation } from '../../../../store/modules/application/types';
import FormDisplay from '../../../../components/FormDisplay';
import Loader from '../../../../components/Loader';

type ViolationDataProps = {
    editForm: Form;
    violationDetails: Violation;
    updateViolation: Function;
    isLoading: Boolean;
    setError: Function;
};
const ViolationData: FunctionComponent<ViolationDataProps> = (props) => {
    const { violationDetails, editForm, isLoading, updateViolation, setError } = props;
    const handleSave = (updatedViolation: Violation) => {
        const { dueDate } = updatedViolation;
        updatedViolation.dueDate = dueDate ? moment(dueDate).format('YYYY-MM-DD') : undefined;
        if (!updatedViolation?.category?.id) {
            setError({
                isError: true,
                errorCode: 400,
                message: 'Violation category is required',
            });
        } else {
            updateViolation(updatedViolation, violationDetails.id);
        }
    };
    if (isLoading) return <Loader />;
    return <FormDisplay form={editForm} record={violationDetails} handleSave={handleSave} />;
};

export default ViolationData;
